// extracted by mini-css-extract-plugin
export default {"overview":"TabsComponent_overview__PbqkF","slider":"TabsComponent_slider__mKG8B","slider_title":"TabsComponent_slider_title__Nu6v7"};